import { ArrowRight } from "lucide-react";

import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import SpotlightCard from "../../SpotlightCard";
import GlobalHeadline from "../../../GlobalHeadline";
import Badge from "../../../Badge";
import { siteSections } from "../../../../content/siteSections";

/**
 * Selected case studies section.
 * Translation: Selected case studies section.
 *
 * @returns {JSX.Element} Work section.
 */
const Work = () => (
  <section id="work" className="section-block section-block--framed">
    <div className="section-shell">
      <SectionHeading
        eyebrow={siteSections.work.eyebrow}
        title={siteSections.work.title}
        description={siteSections.work.description}
      />

      <div className="case-study-list">
        {siteSections.work.cases.map((caseStudy, index) => (
          <Reveal
            key={caseStudy.id}
            variant={index % 2 === 0 ? "fade-right" : "fade-left"}
          >
            <SpotlightCard className="glass-panel case-study-card">
              <div className="case-study-card__number" aria-hidden="true">{caseStudy.number}</div>
              <Badge className="case-study-card__category">{caseStudy.category}</Badge>
              <GlobalHeadline as="h3">{caseStudy.title}</GlobalHeadline>

              <div className="case-study-card__grid">
                <div>
                  <h4>CHALLENGE</h4>
                  <p>{caseStudy.challenge}</p>
                </div>
                <div>
                  <h4>SOLUTION</h4>
                  <p>{Array.isArray(caseStudy.solution) ? caseStudy.solution.join(" ") : caseStudy.solution}</p>
                </div>
              </div>

              <div className="case-study-card__outcome">
                <div className="glow-line" />
                <div className="case-study-card__outcome-content">
                  <div>
                    <h4>OUTCOME</h4>
                    <p>{caseStudy.outcome}</p>
                  </div>
                  {caseStudy.cta ? (
                    <div className="case-study-card__link-wrapper">
                      <a
                        href={caseStudy.cta.href}
                        target="_blank"
                        rel="noreferrer"
                        className="case-study-card__link group"
                        title={`View project: ${caseStudy.title} (Opens in new tab)`}
                      >
                        {caseStudy.cta.label.replace(" ->", "")}
                        <ArrowRight
                          className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform"
                          strokeWidth={1.25}
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
            </SpotlightCard>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Work;
